export default {
    rooms: 'Ruimtes',
    noSensorData: 'Geen sensor data aanwezig',
    noSetpointData: 'Geen data',
    units: {
        // Sensors
        CO2: 'ppm',
        Flow: 'm³/h',
        Humidity: '%',
        Motion: 'Motion',
        Pressure: 'hPa',
        RelayState: 'Aan/uit',
        Temperature: '°C',
        VOC: 'ppb',
        ValveFlowPercentage: '%',
        CurrentPower: 'W',
        CurrentPowerPhase: 'W',
        TotalPower: 'kWh',
        TotalPowerPhase: 'kWh',
        Voltage: 'V',
        Current: 'A',
        TotalGas: 'm³',
        CurrentWaterFlow: 'L/s',
        TotalWater: 'm³',
        // Setpoints
        LightSetpoint: 'Aan/uit',
        MaxTemperature: '°C',
        MinTemperature: '°C',
        PowerSetpoint: 'Aan/uit',
        TemperatureMode: 'Stand',
        VentilationFlowSetpoint: 'm³/h',
        ValveFlowPercentageSetpoint: '%',
    },
    sensors: {
        CO2: 'CO2',
        Flow: 'Ventilatie flow',
        Humidity: 'Luchtvochtigheid',
        Motion: 'Beweging',
        Pressure: 'Luchtdruk',
        RelayState: 'Relay',
        Temperature: 'Temperatuur',
        VOC: 'VOC',
        ValveFlowPercentage: 'Huidige ventilatie (%)',
        CurrentPower: 'Huidig verbruik',
        CurrentPowerPhase: 'Huidig verbruik (per fase)',
        TotalPower: 'Totaal verbruik',
        TotalPowerPhase: 'Totaal verbruik (per fase)',
        Voltage: 'Spanning',
        Current: 'Stroom',
        TotalGas: 'Totaal gasverbruik',
        CurrentWaterFlow: 'Huidig waterverbruik',
        TotalWater: 'Totaal waterverbruik',
    },
    setpoints: {
        LightSetpoint: 'Licht',
        MaxTemperature: 'Maximale temperatuur',
        MinTemperature: 'Minimale temperatuur',
        PowerSetpoint: 'Stroom',
        TemperatureMode: 'Warmtepomp stand',
        ValveFlowPercentageSetpoint: 'Gewenste ventilatie (%)',
        VentilationFlowSetpoint: 'Gewenste ventilatie',
    },
    timeFrameSelection: 'Selecteer een tijdsspanne',
    timeFramePrev: 'Vorige {timeframe}',
    timeFrameNext: 'Volgende {timeframe}',
};
